// extracted by mini-css-extract-plugin
export var copy = "retail-module--copy--2904d";
export var list = "retail-module--list--86e7c";
export var logo = "retail-module--logo--f43b7";
export var retailers = "retail-module--retailers--0bc46";